import { useEffect, useState } from "react";
import { PlanningTransporter } from "src/app/transports/planning";
import { Planning } from "src/app/types/planning";

const usePlanningByMoneySiteId = (moneySiteId?: number, inicialRequest = true) => {
    const [planning, setPlanning] = useState<Array<Planning>>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    const fetch = () => {
        if (!moneySiteId) return;

        setLoading(true);
        PlanningTransporter.findByMoneySiteId(moneySiteId)
            .then((res) => setPlanning(res))
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = async () => {
        if (!loading) await fetch();
    };

    useEffect(() => {
        if (inicialRequest) fetch();
    }, []);

    return { planning, refresh, error, loading };
};

export default usePlanningByMoneySiteId;
